// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BrandCheckerController from "./brand_checker_controller"
application.register("brand-checker", BrandCheckerController)

import BrandCreateController from "./brand_create_controller"
application.register("brand-create", BrandCreateController)

import BrandSelectController from "./brand_select_controller"
application.register("brand-select", BrandSelectController)

import CopyUrlsController from "./copy_urls_controller"
application.register("copy-urls", CopyUrlsController)

import CsvPreviewController from "./csv_preview_controller"
application.register("csv-preview", CsvPreviewController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import DomainSearchController from "./domain_search_controller"
application.register("domain-search", DomainSearchController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FormController from "./form_controller"
application.register("form", FormController)

import LinkController from "./link_controller"
application.register("link", LinkController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import QueryMultiselectController from "./query_multiselect_controller"
application.register("query-multiselect", QueryMultiselectController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)
